export default __webpack_public_path__ + "static/media/activity-group-green.b161605e.svg";